<template>
  <div
    :class="isMobile ? 'center-screen p-5' : 'd-flex justify-content-between'"
  >
    <div :class="isMobile ? 'd-none' : 'w-50 center-screen cover-image'">
      <div class="w-100 h-100 cover-overlay"></div>
    </div>
    <div :class="isMobile ? '' : 'w-50 center-screen px-2'">
      <slot name="form"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainAuthLayout'
}
</script>

<style lang="scss" scoped>
.cover-image {
  background: url('~@/assets/images/cover.jpeg') center center no-repeat;
  background-size: cover;
  opacity: 0.8;
}
.cover-overlay {
  background-blend-mode: multiply;
  background-image: linear-gradient(90deg, rgb(0, 158, 233), rgb(0, 96, 226));
  opacity: 0.7;
}
</style>
